/**
 * The transition type a navigation carries when a project page is on either end
 * of it. Every Front cover travels under it.
 */
export const PROJECT_COVER_TRANSITION_TYPE = "project-cover";
